import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductBoxOpen = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.457 10.4971L21.1219 6.99743C21.053 6.89463 20.9594 6.80673 20.8457 6.74763L12.3457 2.33453C12.1289 2.22223 11.8711 2.22223 11.6543 2.33453L3.15431 6.74763C3.03701 6.80853 2.94101 6.89923 2.87161 7.00603L0.537111 10.6118C0.422411 10.789 0.387711 11.0068 0.441911 11.2109C0.496111 11.415 0.633811 11.5874 0.821311 11.6845L2.75001 12.6861V16.2402C2.75001 16.5205 2.90581 16.7763 3.15431 16.9062L11.6543 21.3203C11.7627 21.376 11.8814 21.4043 12 21.4043C12.1186 21.4043 12.2373 21.376 12.3457 21.3203L20.8457 16.9062C21.0937 16.7763 21.25 16.5205 21.25 16.2402V12.5803L23.1787 11.5786C23.3682 11.4805 23.5058 11.3066 23.5596 11.1001C23.6123 10.8936 23.5751 10.6743 23.457 10.4971ZM2.24511 10.7339L3.75931 8.39313L10.9219 12.1123L9.40771 14.4531L2.24511 10.7339ZM11.5 19.5499L4.25001 15.7842V13.4651L9.32131 16.0986C9.43171 16.1552 9.54981 16.1826 9.66651 16.1826C9.91361 16.1826 10.1543 16.0605 10.2969 15.8398L11.5 13.9805V19.5499ZM12 10.9821L5.12741 7.41313L12 3.84523L18.8726 7.41313L12 10.9821ZM19.75 15.7842L12.5 19.5499V13.9295L13.709 15.7432C13.8526 15.958 14.0899 16.0772 14.333 16.0772C14.4502 16.0772 14.5684 16.0499 14.6787 15.9932L19.75 13.3594V15.7842ZM14.584 14.3516L13.0879 12.1075L20.249 8.38873L21.7451 10.6328L14.584 14.3516Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductBoxOpen.displayName = 'ProductBoxOpen';
